export const convertSalary = (salary) => {
  if (salary) {
    salary = salary.toString();
    if (salary.length >= 4) {
      return salary.slice(0, -3) + 'k';
    } 
    return salary;
  }
}